export default "__VITE_ASSET__CMyEyVAr__"